//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_AGRIROUTER_BASE_URL = new InjectionToken<string>('API_AGRIROUTER_BASE_URL');

export interface IAgrirouterAuthorizationService {
    generateAuthorizationLink(organizationId: string | undefined, accountDisplayName: string | undefined, redirectUrl: string | undefined): Observable<GenerateAuthorizationLinkResponse>;
    onboardApplication(signature: string | undefined, state: string | undefined, token: string | undefined, error: string | undefined): Observable<ProblemDetails>;
    revokeApplication(agrirouterAccountId: string | undefined, organizationId: string | undefined): Observable<GenerateAuthorizationLinkResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterAuthorizationService implements IAgrirouterAuthorizationService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    generateAuthorizationLink(organizationId: string | undefined, accountDisplayName: string | undefined, redirectUrl: string | undefined): Observable<GenerateAuthorizationLinkResponse> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/generate_link?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (accountDisplayName === null)
            throw new Error("The parameter 'accountDisplayName' cannot be null.");
        else if (accountDisplayName !== undefined)
            url_ += "accountDisplayName=" + encodeURIComponent("" + accountDisplayName) + "&";
        if (redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' cannot be null.");
        else if (redirectUrl !== undefined)
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateAuthorizationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateAuthorizationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateAuthorizationLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateAuthorizationLinkResponse>;
        }));
    }

    protected processGenerateAuthorizationLink(response: HttpResponseBase): Observable<GenerateAuthorizationLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenerateAuthorizationLinkResponse;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    onboardApplication(signature: string | undefined, state: string | undefined, token: string | undefined, error: string | undefined): Observable<ProblemDetails> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/onboard_application?";
        if (signature === null)
            throw new Error("The parameter 'signature' cannot be null.");
        else if (signature !== undefined)
            url_ += "Signature=" + encodeURIComponent("" + signature) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (error === null)
            throw new Error("The parameter 'error' cannot be null.");
        else if (error !== undefined)
            url_ += "Error=" + encodeURIComponent("" + error) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnboardApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnboardApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProblemDetails>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProblemDetails>;
        }));
    }

    protected processOnboardApplication(response: HttpResponseBase): Observable<ProblemDetails> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return _observableOf(resultdefault);
            }));
        }
    }

    revokeApplication(agrirouterAccountId: string | undefined, organizationId: string | undefined): Observable<GenerateAuthorizationLinkResponse> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/revoke_application?";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRevokeApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRevokeApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateAuthorizationLinkResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateAuthorizationLinkResponse>;
        }));
    }

    protected processRevokeApplication(response: HttpResponseBase): Observable<GenerateAuthorizationLinkResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenerateAuthorizationLinkResponse;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAgrirouterService {
    onboardVcu(command: OnboardVcuCommand): Observable<string>;
    offboardVcu(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined): Observable<void>;
    getAgrirouterAccounts(organizationId: string | undefined): Observable<OrganizationAgrirouterAccountDto[]>;
    sendNewCapabilities(): Observable<void>;
    listUsersAndAgrirouterAccounts(): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
    sendAgrirouterFileViaMqtt(sendAgrirouterFileViaMqttCommand: SendAgrirouterFileViaMqttCommand): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterService implements IAgrirouterService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    onboardVcu(command: OnboardVcuCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/onboard_vcu";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOnboardVcu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOnboardVcu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processOnboardVcu(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    offboardVcu(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/offboard_vcu?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        if (vin === null)
            throw new Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOffboardVcu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOffboardVcu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOffboardVcu(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getAgrirouterAccounts(organizationId: string | undefined): Observable<OrganizationAgrirouterAccountDto[]> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/agrirouter_accounts?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAgrirouterAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAgrirouterAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationAgrirouterAccountDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationAgrirouterAccountDto[]>;
        }));
    }

    protected processGetAgrirouterAccounts(response: HttpResponseBase): Observable<OrganizationAgrirouterAccountDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganizationAgrirouterAccountDto[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    sendNewCapabilities(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/send_new_capabailities_for_all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewCapabilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewCapabilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendNewCapabilities(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    listUsersAndAgrirouterAccounts(): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]> {
        let url_ = this.baseUrl + "/api/v2/ar_protected/protected_get_user_ar_account_list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUsersAndAgrirouterAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUsersAndAgrirouterAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
        }));
    }

    protected processListUsersAndAgrirouterAccounts(response: HttpResponseBase): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgrirouterAccountsAndOnboardedVcuResponse[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    sendAgrirouterFileViaMqtt(sendAgrirouterFileViaMqttCommand: SendAgrirouterFileViaMqttCommand): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]> {
        let url_ = this.baseUrl + "/api/v2/ar_protected/protected_agrirouter_send_file_mqtt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sendAgrirouterFileViaMqttCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAgrirouterFileViaMqtt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAgrirouterFileViaMqtt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AgrirouterAccountsAndOnboardedVcuResponse[]>;
        }));
    }

    protected processSendAgrirouterFileViaMqtt(response: HttpResponseBase): Observable<AgrirouterAccountsAndOnboardedVcuResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgrirouterAccountsAndOnboardedVcuResponse[];
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAgrirouterTaskDataVehicleService {
    getFilesFromAgrirouter(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTaskDataFileDto>;
    getFilesToAgrirouter(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTaskDataFileDto>;
    getFileByUrl(fileId: string | undefined): Observable<GetTaskDataByUrlDto>;
    deleteFileByUrl(organizationId: string | undefined, fileId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterTaskDataVehicleService implements IAgrirouterTaskDataVehicleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getFilesFromAgrirouter(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTaskDataFileDto> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/taskdata/files_from_agrirouter?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        if (vin === null)
            throw new Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesFromAgrirouter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesFromAgrirouter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTaskDataFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTaskDataFileDto>;
        }));
    }

    protected processGetFilesFromAgrirouter(response: HttpResponseBase): Observable<PagedResponseOfTaskDataFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResponseOfTaskDataFileDto;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getFilesToAgrirouter(organizationId: string | undefined, agrirouterAccountId: string | undefined, vin: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfTaskDataFileDto> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/taskdata/files_to_agrirouter?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        if (vin === null)
            throw new Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFilesToAgrirouter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFilesToAgrirouter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfTaskDataFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfTaskDataFileDto>;
        }));
    }

    protected processGetFilesToAgrirouter(response: HttpResponseBase): Observable<PagedResponseOfTaskDataFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResponseOfTaskDataFileDto;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getFileByUrl(fileId: string | undefined): Observable<GetTaskDataByUrlDto> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/taskdata/file?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFileByUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileByUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTaskDataByUrlDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTaskDataByUrlDto>;
        }));
    }

    protected processGetFileByUrl(response: HttpResponseBase): Observable<GetTaskDataByUrlDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetTaskDataByUrlDto;
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteFileByUrl(organizationId: string | undefined, fileId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/taskdata/file?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFileByUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFileByUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteFileByUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAgrirouterTelemetryService {
    sendDeviceDescription(vin: string | undefined, teamsetContextId: string | null | undefined): Observable<void>;
    sendTelemetry(vin: string | undefined): Observable<void>;
    getLatestPositionsForTelemetryPartners(agrirouterAccountId: string | undefined): Observable<TelemetryPartner[]>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterTelemetryService implements IAgrirouterTelemetryService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sendDeviceDescription(vin: string | undefined, teamsetContextId: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/telemetry/device-description?";
        if (vin === null)
            throw new Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        if (teamsetContextId !== undefined && teamsetContextId !== null)
            url_ += "teamsetContextId=" + encodeURIComponent("" + teamsetContextId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendDeviceDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendDeviceDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendDeviceDescription(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    sendTelemetry(vin: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/telemetry/send-telemetry?";
        if (vin === null)
            throw new Error("The parameter 'vin' cannot be null.");
        else if (vin !== undefined)
            url_ += "vin=" + encodeURIComponent("" + vin) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTelemetry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTelemetry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTelemetry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getLatestPositionsForTelemetryPartners(agrirouterAccountId: string | undefined): Observable<TelemetryPartner[]> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/telemetry/telemetry_partners?";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestPositionsForTelemetryPartners(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestPositionsForTelemetryPartners(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TelemetryPartner[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TelemetryPartner[]>;
        }));
    }

    protected processGetLatestPositionsForTelemetryPartners(response: HttpResponseBase): Observable<TelemetryPartner[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TelemetryPartner[];
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAgrirouterTriggerService {
    getChunksAssembling(): Observable<void>;
    getReceiptClose(): Observable<void>;
    deleteAllMessagesFromFeeds(agrirouterAccountId: string | undefined): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterTriggerService implements IAgrirouterTriggerService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getChunksAssembling(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/trigger/ar_chunks_assembling";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChunksAssembling(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChunksAssembling(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetChunksAssembling(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getReceiptClose(): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/trigger/ar_receipt_close";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptClose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptClose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetReceiptClose(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    deleteAllMessagesFromFeeds(agrirouterAccountId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/trigger/ar_delete_all?";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllMessagesFromFeeds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllMessagesFromFeeds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllMessagesFromFeeds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IAgrirouterVehicleService {
    getVehiclesNotYetOnboarded(organizationId: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfVehicleDto>;
    getVehiclesOnboarded(organizationId: string | undefined, agrirouterAccountId: string | undefined, qSearch: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfOnboardedVehicleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AgrirouterVehicleService implements IAgrirouterVehicleService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getVehiclesNotYetOnboarded(organizationId: string | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/vehicle/not_onboarded?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehiclesNotYetOnboarded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehiclesNotYetOnboarded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfVehicleDto>;
        }));
    }

    protected processGetVehiclesNotYetOnboarded(response: HttpResponseBase): Observable<PagedResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getVehiclesOnboarded(organizationId: string | undefined, agrirouterAccountId: string | undefined, qSearch: string | null | undefined, page: number | undefined, pageSize: number | undefined): Observable<PagedResponseOfOnboardedVehicleDto> {
        let url_ = this.baseUrl + "/api/v2/agrirouter/vehicle/onboarded?";
        if (organizationId === null)
            throw new Error("The parameter 'organizationId' cannot be null.");
        else if (organizationId !== undefined)
            url_ += "organizationId=" + encodeURIComponent("" + organizationId) + "&";
        if (agrirouterAccountId === null)
            throw new Error("The parameter 'agrirouterAccountId' cannot be null.");
        else if (agrirouterAccountId !== undefined)
            url_ += "agrirouterAccountId=" + encodeURIComponent("" + agrirouterAccountId) + "&";
        if (qSearch !== undefined && qSearch !== null)
            url_ += "qSearch=" + encodeURIComponent("" + qSearch) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehiclesOnboarded(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehiclesOnboarded(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResponseOfOnboardedVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResponseOfOnboardedVehicleDto>;
        }));
    }

    protected processGetVehiclesOnboarded(response: HttpResponseBase): Observable<PagedResponseOfOnboardedVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagedResponseOfOnboardedVehicleDto;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IIMonitorLoginService {
    userLogin(userLoginQuery: UserLoginQuery): Observable<AccessTokenDto>;
    userRefreshToken(userRefreshTokenQuery: UserRefreshTokenQuery): Observable<RefreshTokenDto>;
}

@Injectable({
    providedIn: 'root'
})
export class IMonitorLoginService implements IIMonitorLoginService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    userLogin(userLoginQuery: UserLoginQuery): Observable<AccessTokenDto> {
        let url_ = this.baseUrl + "/api/v2/sdf_open/open_user_login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userLoginQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccessTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccessTokenDto>;
        }));
    }

    protected processUserLogin(response: HttpResponseBase): Observable<AccessTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AccessTokenDto;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    userRefreshToken(userRefreshTokenQuery: UserRefreshTokenQuery): Observable<RefreshTokenDto> {
        let url_ = this.baseUrl + "/api/v2/sdf_open/open_user_refresh_token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userRefreshTokenQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenDto>;
        }));
    }

    protected processUserRefreshToken(response: HttpResponseBase): Observable<RefreshTokenDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RefreshTokenDto;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IIMonitorTaskDataService {
    listObjectStorageFiles(getObjectStorageFilesQuery: GetObjectStorageFilesQuery): Observable<ArUploadDownloadResponse>;
    getObjectStorageFileUrl(getObjectStorageFileUrlQuery: GetObjectStorageFileUrlQuery): Observable<GetObjectStorageFileUrlResponse>;
    getObjectStorageFilePutUrl(getObjectStorageFilePutUrlQuery: GetObjectStorageFilePutUrlQuery): Observable<GetObjectStorageFileUrlResponse>;
    updateFileInfoAfterUpload(updateFileInfoAfterUploadCommand: UpdateFileInfoAfterUploadCommand): Observable<GetObjectStorageFileUrlResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class IMonitorTaskDataService implements IIMonitorTaskDataService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    listObjectStorageFiles(getObjectStorageFilesQuery: GetObjectStorageFilesQuery): Observable<ArUploadDownloadResponse> {
        let url_ = this.baseUrl + "/api/v2/sdf_protected/protected_obj_storage_list_files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getObjectStorageFilesQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListObjectStorageFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListObjectStorageFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArUploadDownloadResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArUploadDownloadResponse>;
        }));
    }

    protected processListObjectStorageFiles(response: HttpResponseBase): Observable<ArUploadDownloadResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ArUploadDownloadResponse;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getObjectStorageFileUrl(getObjectStorageFileUrlQuery: GetObjectStorageFileUrlQuery): Observable<GetObjectStorageFileUrlResponse> {
        let url_ = this.baseUrl + "/api/v2/sdf_protected/protected_obj_storage_get_file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getObjectStorageFileUrlQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObjectStorageFileUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObjectStorageFileUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetObjectStorageFileUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetObjectStorageFileUrlResponse>;
        }));
    }

    protected processGetObjectStorageFileUrl(response: HttpResponseBase): Observable<GetObjectStorageFileUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetObjectStorageFileUrlResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    getObjectStorageFilePutUrl(getObjectStorageFilePutUrlQuery: GetObjectStorageFilePutUrlQuery): Observable<GetObjectStorageFileUrlResponse> {
        let url_ = this.baseUrl + "/api/v2/sdf_protected/protected_obj_storage_put_file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getObjectStorageFilePutUrlQuery);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetObjectStorageFilePutUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetObjectStorageFilePutUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetObjectStorageFileUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetObjectStorageFileUrlResponse>;
        }));
    }

    protected processGetObjectStorageFilePutUrl(response: HttpResponseBase): Observable<GetObjectStorageFileUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetObjectStorageFileUrlResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }

    updateFileInfoAfterUpload(updateFileInfoAfterUploadCommand: UpdateFileInfoAfterUploadCommand): Observable<GetObjectStorageFileUrlResponse> {
        let url_ = this.baseUrl + "/api/v2/sdf_protected/protected_user_send_file_information_after_upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateFileInfoAfterUploadCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFileInfoAfterUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFileInfoAfterUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetObjectStorageFileUrlResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetObjectStorageFileUrlResponse>;
        }));
    }

    protected processUpdateFileInfoAfterUpload(response: HttpResponseBase): Observable<GetObjectStorageFileUrlResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetObjectStorageFileUrlResponse;
            return _observableOf(result204);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface IIMonitorUserService {
    postOpenUserLogin(): Observable<UserInfoDto>;
}

@Injectable({
    providedIn: 'root'
})
export class IMonitorUserService implements IIMonitorUserService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_AGRIROUTER_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    postOpenUserLogin(): Observable<UserInfoDto> {
        let url_ = this.baseUrl + "/api/v2/sdf_protected/protected_get_user_info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOpenUserLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOpenUserLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserInfoDto>;
        }));
    }

    protected processPostOpenUserLogin(response: HttpResponseBase): Observable<UserInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoDto;
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export interface GenerateAuthorizationLinkResponse {
    redirect_url?: string;
}

export interface ProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface OnboardVcuCommand {
    agrirouterAccountId?: string;
    vin?: string;
}

export interface OrganizationAgrirouterAccountDto {
    agrirouterAccountId?: string;
    organizationId?: string;
    connectionName?: string;
}

export interface PagedResponseOfTaskDataFileDto {
    data?: TaskDataFileDto[];
    page?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface TaskDataFileDto {
    auth0UserId?: string;
    bucketFileId?: string;
    creationDateTime?: Date;
    creationTimestamp?: number | null;
    dataType?: number | null;
    deleted?: boolean;
    fileName?: string;
    fileSize?: number | null;
    fileType?: string | null;
    vin?: string;
}

export interface GetTaskDataByUrlDto {
    fileId?: string;
    url?: string;
}

export interface TelemetryPartner {
    partnerId?: string;
    partnerName?: string;
    position?: TelemetryPosition;
    lastUpdate?: Date;
    partnerDevices?: TelemetryPartnerDevice[];
}

export interface TelemetryPosition {
    latitude?: number;
    longitude?: number;
}

export interface TelemetryPartnerDevice {
    name?: string;
    clientName?: string;
}

export interface PagedResponseOfVehicleDto {
    data?: VehicleDto[];
    page?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface VehicleDto {
    name?: string;
    userVehiclePhoto?: string;
    vin?: string;
}

export interface PagedResponseOfOnboardedVehicleDto {
    data?: OnboardedVehicleDto[];
    page?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
}

export interface OnboardedVehicleDto {
    endpointId?: string;
    name?: string;
    model?: string;
    userVehiclePhoto?: string;
    vin?: string;
    lastUpdateDt?: Date | null;
    isRunning?: boolean | null;
    ctmStatus?: CtmStatus;
}

export enum CtmStatus {
    NOT_FOUND = 0,
    EXPIRED = 1,
    EXPIRING = 2,
    VALID = 3,
}

export interface AgrirouterAccountsAndOnboardedVcuResponse {
    account?: string;
    name?: string;
    onboarded_vins?: OnboardedVinDto[] | null;
}

export interface OnboardedVinDto {
    enabled?: boolean;
    vcu?: string;
}

export interface SendAgrirouterFileViaMqttCommand {
    ar_account_id?: string;
    file_type?: string;
    recipients?: string[] | null;
    send_mode?: string;
    uploaded_file_id?: string;
    vin?: string;
}

export interface AccessTokenDto {
    access_token?: string;
    expiration?: number;
    refresh_token?: string;
    scope?: string;
}

export interface UserLoginQuery {
    email?: string;
    password?: string;
}

export interface RefreshTokenDto {
    access_token?: string;
    refresh_token?: string;
}

export interface UserRefreshTokenQuery {
    token?: string;
}

export interface ArUploadDownloadResponse {
    ar_download?: ObjectStorageFileDto[] | null;
    uploaded_data?: ObjectStorageFileDto[] | null;
}

export interface ObjectStorageFileDto {
    uuid?: string;
    fileTag?: string;
    creationDate?: string | null;
    dataType?: string | null;
    deleted?: boolean;
    bucketFilename?: string;
    vin?: string;
}

export interface GetObjectStorageFilesQuery {
    ar_account_id?: string;
    page?: number;
    size?: number;
    vin?: string;
}

export interface GetObjectStorageFileUrlResponse {
    file_id?: string;
    url?: string;
}

export interface GetObjectStorageFileUrlQuery {
    file_id?: string;
}

export interface GetObjectStorageFilePutUrlQuery {
    filename?: string;
    file_type?: string;
}

export interface UpdateFileInfoAfterUploadCommand {
    file_id?: string;
    filename?: string;
    fileType?: string;
    vin?: string;
}

export interface UserInfoDto {
    created_at?: Date | null;
    email?: string;
    email_verified?: boolean | null;
    given_name?: string;
    name?: string;
    family_name?: string;
    nickname?: string;
    picture?: string;
    user_id?: string;
    user_metadata?: any;
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}